import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { ChannelContextService } from '@x/ecommerce-shop/app/channel/services/channel-context.service';
import { map } from 'rxjs/operators';

export const channelGatewayGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const channelContext = inject(ChannelContextService);

  return channelContext.suggestedChannel$().pipe(
    map((channel) => {
      if (!channel) return true;

      router.navigate([`/${channel}`], {
        ...(route.queryParams && { queryParams: route.queryParams }),
      });

      return false;
    }),
  );
};
